import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import RESTService from '../api/RESTService';
import { ACTIONS_FETCH, ACTIONS_POST, ACTIONS_SUCCESS, ACTIONS_FAILURE, ROUTE_CHANGED } from './Constants';
/**
 * Utility class that provides useful utility function for producing
 * boilerplate redux functionality.
 * @namespace
 */

var ReduxUtils = /*#__PURE__*/function () {
  function ReduxUtils() {
    _classCallCheck(this, ReduxUtils);
  }

  _createClass(ReduxUtils, null, [{
    key: "generateActionType",

    /* eslint-disable compat/compat */

    /**
     * Generates a boiler plate actions type.
     * @param {string} library The library used to generate the action types.
     * @param {string} featureName The feature name used to generate the action types.
     * @param {string} restVerb The key that will be used to distinguish the action for that
     * feature.
     * @returns Generated action type.
     * @private
     */
    value: function generateActionType(library, featureName, key) {
      var _context, _context2, _context3;

      return _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "").call(_context3, library, "/")).call(_context2, featureName, "/")).call(_context, key);
    }
    /**
     * Generates boiler plate actions types. It will produce 3 action types as
     * documentation on the return type.
     * @param {string} library The library used to generate the action types.
     * @param {string} featureName The feature name used to generate the action types.
     * @param {string} restVerb The rest verb used to generate action types for a feature.
     * @returns Object with three keys, the value of each representing
     * an action: baseAction, successAction, failureAction.
     * @private
     */

  }, {
    key: "generateActionTypes",
    value: function generateActionTypes(library, featureName) {
      var _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11;

      var restVerb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ACTIONS_FETCH;
      var featureNameUpper = featureName.toUpperCase();
      var base = this.generateActionType(library, featureName, _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "").call(_context5, restVerb, "_")).call(_context4, featureNameUpper));
      var success = this.generateActionType(library, featureName, _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = "").call(_context8, restVerb, "_")).call(_context7, featureNameUpper, "_")).call(_context6, ACTIONS_SUCCESS));
      var failure = this.generateActionType(library, featureName, _concatInstanceProperty(_context9 = _concatInstanceProperty(_context10 = _concatInstanceProperty(_context11 = "").call(_context11, restVerb, "_")).call(_context10, featureNameUpper, "_")).call(_context9, ACTIONS_FAILURE));
      return {
        baseAction: base,
        successAction: success,
        failureAction: failure
      };
    }
    /**
     * Generates POST boiler plate actions types. It will produce 3 action types as
     * documentation on the return type.
     * @param {string} library The library used to generate the action types.
     * @param {string} featureName The feature name used to generate the action types.
     * @returns Object with three keys, the value of each representing
     * an action: baseAction, successAction, failureAction.
     * @private
     */

  }, {
    key: "generatePostActionTypes",
    value: function generatePostActionTypes(library, featureName) {
      return this.generateActionTypes(library, featureName, ACTIONS_POST);
    }
    /**
     * Generates FETCH boiler plate actions types. It will produce 3 action types as
     * documentation on the return type.
     * @param {string} library The library used to generate the action types.
     * @param {string} featureName The feature name used to generate the action types.
     * @returns Object with three keys, the value of each representing
     * an action: baseAction, successAction, failureAction.
     * @private
     */

  }, {
    key: "generateFetchActionTypes",
    value: function generateFetchActionTypes(library, featureName) {
      return this.generateActionTypes(library, featureName);
    }
    /**
     * Executes a specified function using the parsed data as the result of an API
     * call by doing the following:
     * (1) Fetching data from a rest API using specified url
     * (2) Parses the raw json data returned from REST call using the
     *    specified Model class as an input.
     * (3) Executing the specified function using the parsed data as an argument.
     * @param {function} restFxnName The callback function that will be executed.
     * @param {string} url The url that will be used to make the REST API call.
     * @param {class} model The specified model class that models the data.
     * @param {string} targetJson The subset of JSON data that is the target data
     * as an input to the model.
     * @private
     */

  }, {
    key: "getParsedDataFromRestAPI",
    value: function getParsedDataFromRestAPI(restFxnName, url, model, targetJson) {
      var _context12, _context13;

      RESTService.get(_concatInstanceProperty(_context12 = _concatInstanceProperty(_context13 = "").call(_context13, process.env.REACT_APP_REST_URL, "/")).call(_context12, url), function (success, json) {
        if (success) {
          var targetData = targetJson ? json[targetJson] : json;
          restFxnName(success, RESTService.parseJson(targetData, model));
        } else {
          restFxnName(success, json);
        }
      });
    }
    /**
     * Executes a specified function using the parsed data as the result of an API
     * call by doing the following:
     *
     * 1. Fetching data from a rest API using specified url.
     *
     * 2. Parses the raw json data returned from REST call using the
     *    specified Model class as an input.
     *
     * 3. Executing the specified function using the parsed data as an argument.
     *
     * @param {function} restFxnName The callback function that will be executed.
     * @param {string} url The url that will be used to make the REST API call.
     * @param {class} model The specified model class that models the data.
     * @param {string} sortSelector An optional selector that if specified will
     * sort the parsed data by the selector.
     * @private
     */

  }, {
    key: "getSortedParsedDataFromRestAPI",
    value: function getSortedParsedDataFromRestAPI(restFxnName, url, model, sortSelector) {
      var _context14, _context15;

      RESTService.get(_concatInstanceProperty(_context14 = _concatInstanceProperty(_context15 = "").call(_context15, process.env.REACT_APP_REST_URL, "/")).call(_context14, url), function (success, json) {
        if (success) {
          var _context16;

          var parsedJSON = sortSelector ? _sortInstanceProperty(_context16 = RESTService.parseJson(json, model)).call(_context16, sortSelector) : RESTService.parseJson(json, model);
          restFxnName(success, parsedJSON);
        } else {
          restFxnName(success, json);
        }
      });
    }
    /**
     * Executes a specified function using the modelled data as the result of an
     * API call by doing the following:
     * (1) Fetching data from a rest API using specified url
     * (2) Crates a new instance of modelled data from REST call using the
     *    specified Model class as an input.
     * (3) Executing the specified function using the modelled data as an argument.
     * @param {function} restFxnName The callback function that will be executed.
     * @param {string} url The url that will be used to make the REST API call.
     * @param {class} Model The specified model class that models the data.
     * @private
     */

  }, {
    key: "getModelDataFromRestAPI",
    value: function getModelDataFromRestAPI(restFxnName, url, Model) {
      var _context17, _context18;

      RESTService.get(_concatInstanceProperty(_context17 = _concatInstanceProperty(_context18 = "").call(_context18, process.env.REACT_APP_REST_URL, "/")).call(_context17, url), function (success, json) {
        if (success) {
          restFxnName(success, new Model(json));
        } else {
          restFxnName(success, json);
        }
      });
    }
    /**
     * Generates a redux action using specified function and action creator.
     * @param {function} dispatchFxn The specified dispatch function that will be
     * executed to dispatch the specified action creator
     * @param {function} restApiFxn The specified REST API function call to
     * get/post the data.
     * @param {Object} action The specified action creator.
     * @param {function} [callback] An optional callback function to be executed
     * after the REST API function call is executed. It will be called with params
     * ({boolean} success, {Object} payload).
     * @private
     */

  }, {
    key: "generateAction",
    value: function generateAction(dispatchFxn, restApiFxn, action, callback) {
      var initialAction = {
        type: action.baseAction,
        payload: {}
      };
      restApiFxn(function (success, payload, header) {
        if (success) {
          dispatchFxn({
            type: action.successAction,
            payload: payload
          });
        } else {
          dispatchFxn({
            type: action.failureAction,
            payload: payload
          });
        }

        if (callback) {
          callback(success, payload, header);
        }
      });
      dispatchFxn(initialAction); // consider removing this in future and let UI components handle
      // default rather than empty object

      return initialAction;
    }
    /**
     * Resets errors back to null or payload in the Redux store by
     * dispatching a payload of null or payload.
     * @param {function} dispatchFxn
     * @param {string} action
     * @private
     */

  }, {
    key: "resetErrorAction",
    value: function resetErrorAction(dispatchFxn, action) {
      var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      dispatchFxn({
        type: action,
        payload: payload
      });
    }
    /**
     * Generates a redux reducer for getting the data of a feature.
     * @param {Object} state The initial state for the reducer.
     * @param {function} action The specified action creator.
     * @param {Object} actions The list of action types.
     * @param {string[]} routesSpan The list of route names to keep the state. The state is wiped if not in one of these routes.
     * @returns Reducer function for getting the data of a feature.
     * @private
     */

  }, {
    key: "generateReducer",
    value: function generateReducer(state, action, actions, routesSpan) {
      var _context19; // Clears the state if route changed to a route not defined in routesSpan


      if (action.type === ROUTE_CHANGED && state.routesSpan && !_someInstanceProperty(_context19 = state.routesSpan).call(_context19, function (url) {
        var _context20;

        return _includesInstanceProperty(_context20 = action.payload.pathname).call(_context20, url);
      })) {
        return _Object$assign({}, state, {
          payload: null
        });
      }

      if (action.type === actions.successAction) {
        return _Object$assign({}, state, {
          payload: action.payload,
          routesSpan: routesSpan
        });
      }

      return state;
    }
    /**
     * Generates a redux reducer for determining if the data of a feature is in
     * the process of being fetched.
     * @param {Object} state The initial state for the reducer.
     * @param {function} action The specified action creator.
     * @param {Object} actions The list of action types.
     * @returns Reducer function for determining if the data of a feature is in the
     * process of being fetched.
     * @private
     */

  }, {
    key: "generateFetchingReducer",
    value: function generateFetchingReducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      var actions = arguments.length > 2 ? arguments[2] : undefined;

      switch (action.type) {
        case actions.baseAction:
          return _Object$assign({}, state, {
            payload: true
          });

        case actions.successAction:
        case actions.failureAction:
          return _Object$assign({}, state, {
            payload: false
          });

        default:
          return state;
      }
    }
    /**
     * Generates a redux reducer for determining if the data of a feature
     * is in the process of being fetched.
     * @param {Object} state The initial state for the reducer.
     * @param {function} action The specified action creator.
     * @param {Object} actions The list of action types.
     * @returns Reducer function for determining if the data of a feature
     * is in the process of being fetched.
     * @private
     */

  }, {
    key: "generateErrorReducer",
    value: function generateErrorReducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      var actions = arguments.length > 2 ? arguments[2] : undefined;

      switch (action.type) {
        case actions.failureAction:
          return _Object$assign({}, state, {
            payload: action.payload
          });

        case actions.baseAction:
        case actions.successAction:
          return state;

        default:
          return state;
      }
    }
    /**
     * Generates a redux selector for determining if the data of a feature or global
     * is in the process of being fetched.
     *
     * @static
     * @memberof ReduxUtils
     * @returns selector function for determining if the data of a feature or global
     * is in the process of being fetched.
     */

  }]);

  return ReduxUtils;
}();

_defineProperty(ReduxUtils, "generateGlobalFetchingSelector", function (state, feature) {
  var _context22, _context23;
  /** Filter state by feature indicator. */


  var stateByFeature = function stateByFeature(_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        featureIndicator = _ref2[0];

    return feature === undefined || feature === 'default' || featureIndicator === feature;
  };
  /** Verify if the action is being loaded */


  var isActionLoading = function isActionLoading(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        actionState = _ref4[1];

    return actionState && _Object$keys(actionState).length === 1 && actionState.payload === true;
  };
  /** Verify if a feature is being loaded */


  var isFeatureLoading = function isFeatureLoading(_ref5) {
    var _context21;

    var _ref6 = _slicedToArray(_ref5, 2),
        featureState = _ref6[1];

    return featureState ? _someInstanceProperty(_context21 = _Object$entries(featureState)).call(_context21, isActionLoading) : false;
  };

  return _someInstanceProperty(_context22 = _filterInstanceProperty(_context23 = _Object$entries(state)).call(_context23, stateByFeature)).call(_context22, isFeatureLoading);
});

_defineProperty(ReduxUtils, "generateGlobalFetchingReducer", function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  if (type && typeof type === 'string' && _includesInstanceProperty(type).call(type, ACTIONS_FETCH)) {
    var _context24, _context25;

    var matches = new RegExp(_concatInstanceProperty(_context24 = _concatInstanceProperty(_context25 = "(.*)_(").call(_context25, ACTIONS_SUCCESS, "|")).call(_context24, ACTIONS_FAILURE, ")")).exec(type);
    var payload = true;
    var requestName = type;

    if (matches) {
      var _matches = _slicedToArray(matches, 2),
          requestMatch = _matches[1];

      payload = false;
      requestName = requestMatch;
    }

    return _Object$assign({}, state, _defineProperty({}, requestName, {
      payload: payload
    }));
  }

  return state;
});

_defineProperty(ReduxUtils, "generateGlobalErrorSelector", function (state) {
  var _context27, _context28, _context29, _context30;

  var feature = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UAErrors';
  /** Filter state by feature indicator. */

  var stateByFeature = function stateByFeature(_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
        featureIndicator = _ref8[0];

    return featureIndicator === feature;
  };
  /** Verify if the action payload has errors */


  var isErrorPayload = function isErrorPayload(_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        actionState = _ref10[1];

    return actionState && actionState.payload && _typeof(actionState.payload) === 'object' && _Object$entries(actionState.payload).length !== 0;
  };
  /** Verify if a feature state has errors */


  var isFeatureWithError = function isFeatureWithError(_ref11) {
    var _context26;

    var _ref12 = _slicedToArray(_ref11, 2),
        featureState = _ref12[1];

    return _someInstanceProperty(_context26 = _Object$entries(featureState)).call(_context26, isErrorPayload);
  };

  var featureWithErrors = _findInstanceProperty(_context27 = _filterInstanceProperty(_context28 = _Object$entries(state)).call(_context28, stateByFeature)).call(_context27, isFeatureWithError);

  return featureWithErrors ? _reduceInstanceProperty(_context29 = _filterInstanceProperty(_context30 = _Object$entries(featureWithErrors[1])).call(_context30, isErrorPayload)).call(_context29, function (errorsData, action) {
    errorsData.push(_Object$assign({}, action[1].payload));
    return errorsData;
  }, []) : null;
});

_defineProperty(ReduxUtils, "generateGlobalErrorReducer", function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  if (type && typeof type === 'string') {
    var _context31, _context32;

    var matches = new RegExp(_concatInstanceProperty(_context31 = _concatInstanceProperty(_context32 = "(.*)_(").call(_context32, ACTIONS_SUCCESS, "|")).call(_context31, ACTIONS_FAILURE, ")")).exec(type);
    var requestName = type;

    if (matches) {
      var _matches2 = _slicedToArray(matches, 3),
          requestMatch = _matches2[1],
          actionResult = _matches2[2];

      requestName = requestMatch;
      return _Object$assign({}, state, actionResult === ACTIONS_FAILURE ? _defineProperty({}, requestName, {
        payload: payload
      }) : _defineProperty({}, requestName, {}));
    }

    if (type === ROUTE_CHANGED) {
      return {};
    }
  }

  return state;
});

export { ReduxUtils as default };